import {
    getAdUnitsListRequest,
    getCampaignByIdRequest,
    isLocationChangeAction,
    CampaignUrl,
    EditCampaignUrl
} from "@common";
import { AppState, currentClientId } from "@store";
import { FetchingState } from "rd-redux-http";
import { Action } from "redux";
import { all, select, takeEvery } from "redux-saga/effects";

function* loadAdUnitListCore() {
    const appState: AppState = yield select();
    const clientId = currentClientId(appState);

    if (!clientId) {
        return;
    }

    if (
        FetchingState.isInitial(appState.adUnitBuilder.adUnitList) ||
        FetchingState.isError(appState.adUnitBuilder.adUnitList)
    ) {
        try {
            yield* getAdUnitsListRequest.saga({ clientId });
        } catch (e) {
            console.log(e);
        }
    }
}

export function* loadAdUnitList() {
    yield all([
        takeEvery(
            (a: Action) =>
                getCampaignByIdRequest.actions.isOk(a) ||
                (isLocationChangeAction(a) &&
                    (CampaignUrl.match(a.payload, false).isMatched ||
                        EditCampaignUrl.match(a.payload, false).isMatched)),
            loadAdUnitListCore
        )
    ]);
}
